/**
 * "Happy birthday" across the welcome page, on the reader's birthday by their own calendar
 * (Tim, 2026-10-14). authUser carries the month and day only ("MM-DD"), so no year or age is
 * ever on the page. A 29 February birthday is kept on 28 February in a year without one.
 */

import { useEsStrings } from '../../common/EsStrings';

const isLeap = ( pYear ) => ( pYear % 4 === 0 && pYear % 100 !== 0 ) || pYear % 400 === 0;

/** Whether pMonthDay ("MM-DD") is pToday's birthday in local time. */
export function esIsBirthday( pMonthDay, pToday = new Date() ) {
    if ( !pMonthDay || !/^\d{2}-\d{2}$/.test( pMonthDay ) ) return false;

    const [ aMonth, aDay ] = pMonthDay.split( '-' ).map( Number );
    const aTodayMonth = pToday.getMonth() + 1;
    const aTodayDay = pToday.getDate();

    if ( aMonth === aTodayMonth && aDay === aTodayDay ) return true;
    return aMonth === 2 && aDay === 29 && aTodayMonth === 2 && aTodayDay === 28
        && !isLeap( pToday.getFullYear() );
}

export default function EsBirthdayBanner( { birthday, name, today } ) {
    const t = useEsStrings();
    if ( !esIsBirthday( birthday, today ?? new Date() ) ) return null;

    return (
        <div data-testid="es-welcome-birthday" role="status"
             className="mb-8 rounded-xl border-2 border-accent bg-well px-6 py-8 text-center">
            <i className="pi pi-gift mb-3 text-5xl text-accent" aria-hidden="true" />
            <p className="text-4xl font-bold text-heading sm:text-5xl">
                { name ? t( 'welcome-birthday-named', 'Happy birthday, {name}!', { name } ) : t( 'welcome-birthday', 'Happy birthday!' ) }
            </p>
        </div>
    );
}
